var _excluded = ["property"];
var _templateObject;
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { css } from '@emotion/core';
import { AgentSideboxGraphQL } from '@domain-group/fe-co-allhomes-enquiry-form';
import ShareButtons from '@domain-group/fe-co-allhomes-share-buttons';
import ListingType from '@domain-group/fe-allhomes-library/lib/enums/listing-type';
import { EventBoundary } from '@domain-group/fe-co-allhomes-analytics';
import { jsx as ___EmotionJSX } from "@emotion/core";
var shareButtonsStyle = {
  name: "er6if3",
  styles: "margin-top:24px;width:100%;"
};
var fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment OnMarketSidebox on Property {\n    address {\n      line1\n      division {\n        name\n      }\n    }\n    ...AgentSidebox\n  }\n  ", "\n"])), AgentSideboxGraphQL.fragment);
var OnMarketSidebox = _ref => {
  var _property$address$div;
  var property = _ref.property,
    props = _objectWithoutProperties(_ref, _excluded);
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(AgentSideboxGraphQL, {
    property: property,
    applyOnlineLink: props.applyOnlineLink,
    onEmailClick: props.onEmailClick
  }), property.listing.type !== ListingType.SALES_EARLY_ACCESS.name && ___EmotionJSX(EventBoundary, {
    name: "share"
  }, ___EmotionJSX(ShareButtons, {
    css: shareButtonsStyle,
    title: "".concat(property.address.line1, ", ").concat((_property$address$div = property.address.division) === null || _property$address$div === void 0 ? void 0 : _property$address$div.name),
    facebook: true,
    twitter: true,
    email: {
      enabled: true,
      link: props.emailAFriendLink
    },
    print: {
      enabled: property.listing.type !== ListingType.DEVELOPMENTS_RESIDENTIAL.name,
      link: props.printFriendlyLink
    }
  })));
};
OnMarketSidebox.fragment = fragment;
OnMarketSidebox.propTypes = {
  property: PropTypes.shape({
    listing: PropTypes.shape({
      type: PropTypes.string
    }),
    address: PropTypes.shape({
      line1: PropTypes.string,
      division: PropTypes.shape({
        name: PropTypes.string
      })
    })
  }).isRequired,
  applyOnlineLink: PropTypes.string,
  emailAFriendLink: PropTypes.string,
  printFriendlyLink: PropTypes.string,
  onEmailClick: PropTypes.func
};
OnMarketSidebox.defaultProps = {
  applyOnlineLink: undefined,
  emailAFriendLink: undefined,
  printFriendlyLink: undefined,
  onEmailClick: () => {}
};
export default OnMarketSidebox;